import { render, staticRenderFns } from "./ThgBillingOverviewCard.vue?vue&type=template&id=12fb9e98"
import script from "./ThgBillingOverviewCard.vue?vue&type=script&lang=ts"
export * from "./ThgBillingOverviewCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports